import { __ } from '@wordpress/i18n';

import  ResetAttributes  from '../../../general/ResetButton.js'

import { useState, useEffect } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { useEntityRecords } from '@wordpress/core-data';

import { InspectorControls } from '@wordpress/block-editor';
import { 
  PanelBody, 
  TextControl, 
  SelectControl,
  Flex,
  FlexItem,
  ToggleControl
} from '@wordpress/components';


const allowedBlocks = [ 'core/query' ];
const extraFiltersDefaults = {
  aOn: false,  
  metaKey: '',
  metaCompare: '',
  metaValue: '',
  metaKeyOrderBy: '',
  orderby: '',
  relation:'',
  metaKey2: '',
  metaCompare2: '',
  metaValue2: '',
}

const addAttributes = ( settings, name ) => {	

  if ( !allowedBlocks.includes( name ) ) return settings;	

	if ( typeof settings.attributes !== 'undefined' ) {	
    if ( settings.attributes.query ) { 
      settings.attributes.query = {
        ...settings.attributes.query,
        default: {
          ...(settings.attributes.query.default || {}),
          extraFilters: extraFiltersDefaults,
        }
      }
    }
  }
	return settings;
}



const addInspectorControl = ( BlockEdit ) => ( props ) => {

  if ( ! allowedBlocks.includes( props.name ) ) {
    return ( <BlockEdit { ...props } /> );
  }

  return (
    <>  
      <BlockEdit { ...props } />
        <InspectorControls>
          { <MetaFilterSelector {...props }/> } 
        </InspectorControls>
    </>
  ) 
}


const MetaFilterSelector = ( props ) => {
  const { attributes, setAttributes } = props;
	const { query } = attributes;
  const {    
    postType,   
    extraFilters = {},
  } = query;

  const orgDefaults = {
		...extraFiltersDefaults,
		...(attributes.query.extraFilters || {}),
	};

	const { 
    aOn,
   	metaKey,
    metaCompare,
    metaValue,
    metaKeyOrderBy,
    orderby,
    relation,
    metaKey2,
    metaCompare2,
    metaValue2,
	} = orgDefaults;



  const isDifferentFromDefault = ( JSON.stringify({...extraFilters, aOn: undefined }) !== JSON.stringify({...extraFiltersDefaults, aOn: undefined }) ) && ( JSON.stringify({...extraFilters }) !== '{}' ) ;
  
  const { records, isResolving } = useEntityRecords('postType', postType, {
    per_page: 1,    
  })

  if( isResolving ){ return <p>Loading...</p> } 
  
  // grab post meta without post_id
  const registerMetakeys = records?.[0]?.meta || {};
  const registerMetaCompare = ['',  '=', '!=', '>', '>=', '<', '<=', 'LIKE', 'NOT LIKE', 'IN', 'NOT IN', 'BETWEEN', 'NOT BETWEEN', 'NOT EXISTS', 'REGEXP', 'NOT REGEXP','RLIKE']
  

  let metakeysOptions = [ {label:'', value:''} ]
  Object.keys(registerMetakeys).forEach( (item) =>{
    metakeysOptions.push({
      label: item,
      value: item
    })
  })

	return (
		<>
    { Object.keys(registerMetakeys).length > 0 && <>
      <PanelBody title={ __( 'Filter by Meta Key', 'aver' ) } initialOpen={false}>  

        <Flex>
          <FlexItem>
            <ToggleControl
              label={__('Enable Meta Filter', 'aver')}
              checked={aOn}
              onChange={
                (val) => setAttributes({ query: { ...attributes.query, extraFilters: {...extraFilters, aOn: val } } })
              }
            />
          </FlexItem>
          <FlexItem>
            { isDifferentFromDefault && (
              <ResetAttributes
                onConfirm={() => {                
                  setAttributes({ query: { ...attributes.query, extraFilters: extraFiltersDefaults } })							
                }}
              /> 
            )}
          </FlexItem>
        </Flex>				

        { aOn && <><SelectControl
          label={ __( 'Meta Key', 'aver' ) }             
          options={ metakeysOptions }              
          value={ metaKey }
          onChange={ ( value ) => {
            setAttributes({ query: { ...attributes.query, extraFilters: {...extraFilters, metaKey: value } } });
          }}
        />

        <SelectControl
          label={ __( 'Meta Compare', 'aver' ) }             
          options={ registerMetaCompare.map( (item) =>{ return { label: item, value: item } } ) }              
          value={ metaCompare }
          onChange={ ( value ) => {
            setAttributes({
              query: {
                ...attributes.query,
                extraFilters: { ...extraFilters, metaCompare: value }
              },
            });
          }}
        />

        <TextControl
          label={ __( 'Meta Value eg: YYYY-MM-DD or today or...', 'aver' ) }               
          value={ metaValue || '' }
          onChange={ ( value ) => {
            setAttributes({
              query: {
                ...attributes.query,
                extraFilters: { ...extraFilters, metaValue: value }
              },
            });
          }}
        /> 

        <SelectControl
          label={ __( 'Meta Relation', 'aver' ) }      
          options={ [
              { label: __( '', 'aver' ), value: '' },
              { label: __( 'AND', 'aver' ), value: 'AND' },
              { label: __( 'OR', 'aver' ), value: 'OR' },                   
          ] }                      
          value={ relation }
          onChange={ ( value ) => {
            setAttributes({
              query: {
                ...attributes.query,
                extraFilters: { ...extraFilters, relation: value }
              },
            });
          }}
        /></> }  

      </PanelBody>	

      { aOn && <PanelBody title={ __( 'Filter by Meta Key2', 'aver' ) } initialOpen={false}>  

        <SelectControl
          label={ __( 'Meta Key2', 'aver' ) }             
          options={ metakeysOptions }              
          value={ metaKey2 }
          onChange={ ( value ) => {
            setAttributes({ query: { ...attributes.query, extraFilters: {...extraFilters, metaKey2: value } } });
          }}
        />

        <SelectControl
          label={ __( 'Meta Compare2', 'aver' ) }             
          options={ registerMetaCompare.map( (item) =>{ return { label: item, value: item } } ) }              
          value={ metaCompare2 }
          onChange={ ( value ) => {
            setAttributes({
              query: {
                ...attributes.query,
                extraFilters: { ...extraFilters, metaCompare2: value }
              },
            });
          }}
        />

        <TextControl
          label={ __( 'Meta Value2 eg: YYYY-MM-DD or today or...', 'aver' ) }               
          value={ metaValue2 || '' }
          onChange={ ( value ) => {
            setAttributes({
              query: {
                ...attributes.query,
                extraFilters: { ...extraFilters, metaValue2: value }
              },
            });
          }}
        />  

      </PanelBody>}	

      { aOn && <PanelBody title={ __( 'Order by Meta Key', 'aver' ) } initialOpen={false}>
        <SelectControl
          label={ __( 'Meta Key for OrderBy', 'aver' ) }             
          options={ metakeysOptions }
          value={ metaKeyOrderBy }
          onChange={ ( value ) => {
            setAttributes({
              query: {
                ...attributes.query,
                extraFilters: { ...extraFilters, metaKeyOrderBy: value },
              },
            });
          }}
        />

        <SelectControl
          label={ __( 'OrderBy.', 'aver' ) }
          options={ [
              { label: __( 'Default', 'aver' ), value: '' },
              { label: __( 'Date', 'aver' ), value: 'date' },
              { label: __( 'Title', 'aver' ), value: 'title' },
              { label: __( 'Random', 'aver' ), value: 'rand' },
              { label: __( 'Meta Value', 'aver' ), value: 'meta_value' },
              { label: __( 'Meta Value (Numeric)', 'aver' ), value: 'meta_value_num' },
          ] }        
          value={ orderby }
          onChange={ ( value ) => {
            setAttributes({
              query: {
                ...attributes.query,
                extraFilters: { ...extraFilters, orderby: value },
              },
            });
          }}
        />
      </PanelBody> }
      
    </> }
    </>
	);
}

const applyExtraClassEditor = (BlockListBlock) => (props) => {

  if (!allowedBlocks.includes(props.name)) return <BlockListBlock {...props} />	

  const { name, setAttributes, attributes, wrapperProps, className } = props;
  const { query } = attributes;
  const { extraFilters = {} } = query;


  // clean up the attributes saved in database
  // useEffect( () => {
  //   if ( !allowedBlocks.includes( name ) )  return 
      
  //   if ( !extraFilters )  return 

  //   const updatedata = {};
  //   for ( const key in extraFilters ) {
  //     const val = extraFilters[ key ];
  //     const def = extraFiltersDefaults[ key ];

  //     if (val === undefined) continue;

  //     if ( JSON.stringify( val ) !== JSON.stringify( def ) && val !== '' ) {
  //       updatedata[ key ] = val;        
  //     }
  //   }   

  //   // If updatedata is empty, remove extraFilters
  //   if (Object.keys(updatedata).length === 0) {
  //     setAttributes({
  //       query: {
  //         ...query,
  //         extraFilters: undefined, // 👈 This ensures WordPress doesn’t save it
  //       },
  //     });
  //   } else {
  //     setAttributes({
  //       query: {
  //         ...query,
  //         extraFilters: updatedata,
  //       },
  //     });
  //   }
    
  // }, [ name, JSON.stringify(extraFilters) ] );


  useEffect(() => {
    if (!allowedBlocks.includes(name)) return;
    if (!extraFilters) return;

    const updatedata = {};
    for (const key in extraFilters) {
      const val = extraFilters[key];
      const def = extraFiltersDefaults[key];
      if (val === undefined) continue;
      if (JSON.stringify(val) !== JSON.stringify(def) && val !== '') {
        updatedata[key] = val;
      }
    }

    // Build newQuery object
    const newQuery = {
      ...query,
      extraFilters:
        Object.keys(updatedata).length === 0 ? undefined : updatedata,
    };

    // Compare with current, break the loop
    if (JSON.stringify(newQuery) !== JSON.stringify(query)) {
      setAttributes({ query: newQuery });
    }

  }, [name, JSON.stringify(extraFilters)]);
  


  return (
  <BlockListBlock
    { ...props }
    wrapperProps={wrapperProps}
    className={className}
  />
)
}



addFilter(
  'blocks.registerBlockType',
  'core/query-extra-attributes',
  addAttributes
);

addFilter( 
  'editor.BlockEdit', 
  'core/query-extra-advanced-control', 
  addInspectorControl 
);

addFilter(
  'editor.BlockListBlock', 
  'aver/query-extra-editor-class', 
  applyExtraClassEditor
);